var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NoSSR',[_c('noindex',[_c('UiObserveVisibility',{class:_vm.$style.wrap,on:{"click":_vm.processClickAdd,"visible":_vm.processViewAdd}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.script)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }